export {
  getComparatorOptions,
  getComparatorOptionsFromAcceptableFilters,
} from './comparator-utils'

export {
  escapeTerm,
  getNode,
  parseNode,
  getDefaultValueByComparator,
} from './lucene-comparator'

// These are used to be able to update Lucene queries into AST then append/remove/replace the nodes
// to update filters and stringify back to the Lucene filter query string
export {
  appendNode,
  convertDateOpsToRefs,
  convertRefsToDateOps,
  hasDateOperations,
  isQueryUnsupportedInUi,
  parseQuery,
  removeNode,
  replaceNode,
  stringifyQuery,
} from './lucene-utils'

// This is used to parse a Lucene query string into the RequestFilter which Query API GetObjects does
// So we replicate the logic to allow bypassing the Query API
export {
  parseQueryToRequestFilter,
  type FieldSchema,
} from './parse-query-to-request-filter/parse-query-to-request-filter'

// This is a utility to flatten a DataSchema into a FieldSchema
export { flattenSchema } from './parse-query-to-request-filter/utils'

export {
  getFieldDefinition,
  getFieldComparatorOptions,
  isValidComparator,
} from './simple-query-helpers'

export * from './date-operations'

export {
  parseQueryToFilter,
  DEFAULT_EMPTY_FILTER,
} from './parse-query-to-filter'
